<!--商品基本信息，包括：价格、名称、活动状态-->
<template>
  <div class="groupon">
    <div class="group-wrap" v-if="grouponList && grouponList.length">
      <div class="row-box group-box">
        <div :class="['row-item', { 'no-more': !hasMore }]" @click="openList">他们正在拼团 可直接参与</div>
        <div class="g-list">
          <template v-if="grouponList.length < 3">
            <div class="item listl2" v-for="(item, index) in grouponList" :key="index">
              <GrouponItem
                :groupItemInfo="item"
                :cIndex="index"
                @joinGroup="joinGroup(item.grouponId)"
                @refreshGroupon="refreshGrouponList"
                v-track="{
                  act: 'show',
                  params: {
                    cfrom: '187|001|02|077',
                    event_id: '187|001|02|077',
                    page_name: 1,
                    group_buy_content: 1,
                    sku_id: skuInfo.commoditySkuBaseInfo.skuId,
                    grouponid: item.grouponId
                  }
                }"
              ></GrouponItem>
            </div>
          </template>
          <template v-else>
            <v-swipe :autoplay="4000" vertical :show-indicators="false" class="listg2">
              <v-swipe-item
                class="item"
                v-for="(item, index) in grouponItemList"
                :style="{ height: itemHeight }"
                :key="index"
              >
                <GrouponItem
                  :groupItemInfo="gItem"
                  :cIndex="index"
                  @joinGroup="joinGroup(gItem.grouponId)"
                  @refreshGroupon="refreshGrouponList"
                  v-for="(gItem, gIndex) in item"
                  :key="gIndex"
                  class="item-space"
                  v-track="{
                    act: 'show',
                    params: {
                      cfrom: '187|001|02|077',
                      event_id: '187|001|02|077',
                      page_name: 1,
                      group_buy_content: 1,
                      sku_id: skuInfo.commoditySkuBaseInfo.skuId,
                      grouponid: gItem.grouponId
                    }
                  }"
                ></GrouponItem>
              </v-swipe-item>
            </v-swipe>
          </template>
        </div>
      </div>
      <!--参团列表弹框-->
      <v-os-popup
        v-model="isShowList"
        title="他们正在拼团  可直接参与"
        :footerShow="false"
        @close="togglePopup('isShowList', false)"
        :minHeightFill="false"
        class="g-pop"
        container="body"
      >
        <div class="list-wrap">
          <template v-for="(item, index) in grouponListAll">
            <GrouponItem
              :groupItemInfo="item"
              :cIndex="index"
              :key="index"
              v-if="index < 10"
              @joinGroup="joinGroup(item.grouponId)"
            ></GrouponItem>
          </template>
        </div>
        <div class="more-tips" v-if="grouponList.length >= 10">仅显示10个可参与的拼团</div>
      </v-os-popup>
    </div>
    <div v-if="grouponList.length" class="head-line border1px"></div>
    <!-- 拼团玩法 -->
    <v-list-view
      name="玩法"
      @click="playInfoClick"
      v-if="grouponRuleInfo"
      right-icon="arrow-right-v3"
      v-track="[
        {
          act: 'show',
          params: {
            cfrom: '187|001|02|077',
            event_id: '187|001|02|077',
            page_name: 1,
            group_buy_content: 2,
            sku_id: skuInfo.commoditySkuBaseInfo.skuId
          }
        },
        {
          act: 'click',
          params: {
            cfrom: '187|001|01|077',
            event_id: '187|001|01|077',
            page_name: 1,
            group_buy_content: 2,
            sku_id: skuInfo.commoditySkuBaseInfo.skuId
          }
        }
      ]"
    >
      <div
        v-track="{
          act: 'show',
          params: {
            cfrom: '081|063|02|077',
            event_id: '081|063|02|077',
            goodtype: goodsType,
            goodid: skuId,
            module: 1,
            pagetype: 0
          }
        }"
      >
        开团/参团 > 邀请好友 > 满员发货
      </div>
    </v-list-view>
    <v-os-popup
      container="body"
      v-model="isShowPopOfIntroduce"
      title="拼团玩法"
      :footerShow="false"
      @close="isShowPopOfIntroduce = false"
    >
      <div class="groupon-rule-pop" v-html="grouponRuleInfo"></div>
    </v-os-popup>
  </div>
</template>

<script>
import GrouponItem from '../groupon-list-item'
import API from 'api'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import { getGrouponList } from '../../index/api'

export default {
  name: 'GrouponIng',
  components: {
    GrouponItem
  },
  computed: {
    ...mapState('detailv3', ['spuInfo', 'skuInfo']),
    ...mapGetters('detailv3', ['isSimpleGroup', 'goodsType', 'skuId']),
    promotionId() {
      return this.skuInfo.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon?.promotionId || ''
    },
    grouponRuleInfo() {
      return this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon?.grouponRuleDesc || ''
    }
  },
  watch: {
    promotionId: {
      handler(newId, oldId) {
        if (newId) {
          this.refreshGrouponList()
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      grouponList: [], // 滚动的参团列表
      grouponItemList: [], // 参团分组，两个一组
      grouponListAll: [], // 所有参团列表
      hasMore: false, // 是否还有更多参团列表
      isShowList: false, // 是否展示参团列表弹层
      isShowPopOfIntroduce: false,
      itemHeight: null
    }
  },
  mounted() {
    // this.refreshGrouponList()
    // 监视参团列表是否可视区域，当可见时隐藏快速参团，不可见时展示快速参团
    this.IO = new IntersectionObserver(
      entries => {
        if (entries[0].intersectionRatio > 0.8) {
          this['UPDATE_QUICKGROUPON_VISIBILITY'](false)
        } else {
          this['UPDATE_QUICKGROUPON_VISIBILITY'](true)
        }
      },
      { threshold: [0.8] }
    )
    this.$nextTick(() => {
      this.IO.observe(document.querySelector('.groupon'))
    })
  },
  beforeDestroy() {
    this.IO.unobserve(this.$el)
  },
  methods: {
    ...mapMutations('detailv3', ['UPDATE_QUICKGROUPON_DATA', 'UPDATE_QUICKGROUPON_VISIBILITY']),
    ...mapActions('detailv3', ['showSkuSelect', 'savePreFocusElByEvent']),
    // 获取参团列表
    async refreshGrouponList() {
      let data
      try {
        let commoditySpu = this.spuInfo.commoditySpu.id
        data = await getGrouponList({ spuId: commoditySpu, promotionId: this.promotionId }).catch(e => {
          this.grouponList = []
          this.grouponItemList = []
          this.grouponListAll = []
          this['UPDATE_QUICKGROUPON_DATA']('')
        })
      } catch (e) {}
      if (data && data.length) {
        // 获取前10条数据
        this.grouponList = data.slice(0, 10)
        this.grouponListAll = data.slice(0, 10)
        // this.grouponList = data.concat(data).concat(data).concat(data)
        // 获取偶数条数据
        if (this.grouponList.length % 2 != 0 && this.grouponList.length > 1) {
          this.grouponList.pop()
        }
      } else {
        this.grouponList = []
        this.grouponItemList = []
        this.grouponListAll = []
      }
      // 把参团列表分组，每两条作为一个swiper item
      let step = 0
      this.grouponList.forEach((item, index) => {
        if (index == 0) {
          this.grouponItemList[step] = []
        }
        if (index != 0 && index % 2 == 0) {
          step++
          this.grouponItemList[step] = []
        }
        this.grouponItemList[step].push(item)
      })

      // 获取参团列表第一个作为快速参团
      if (this.grouponList[0]) {
        this['UPDATE_QUICKGROUPON_DATA'](this.grouponList[0])
      } else {
        this['UPDATE_QUICKGROUPON_DATA']('')
      }
      if (this.grouponListAll.length > 2) {
        this.hasMore = true
      } else {
        this.hasMore = false
      }
      // 解决拼团滚动样式对不上的问题
      this.$nextTick(() => {
        try {
          this.itemHeight = `${document.querySelector('.listg2').clientHeight}px`
        } catch (error) {}
      })
    },
    // 展示更多参团列表
    openList() {
      // 点击参团弹层需刷新列表，因currentTime会变
      // this.refreshGrouponList()
      if (this.hasMore) {
        this.togglePopup('isShowList', true)
      }
    },
    playInfoClick(e) {
      this.savePreFocusElByEvent(e)
      this.isShowPopOfIntroduce = true
      this.$track({
        cfrom: '081|063|01|077',
        event_id: '081|063|01|077',
        goodtype: this.goodsType,
        goodid: this.skuId,
        module: 1,
        pagetype: 0
      })
    },
    // 弹框显示隐藏
    togglePopup(key, flag) {
      this[key] = flag
    },
    // 参团
    joinGroup(grouponId) {
      API.logAll({
        cfrom: '187|001|01|077',
        event_id: '187|001|01|077',
        page_name: 1,
        group_buy_content: 1,
        sku_id: this.skuInfo?.commoditySkuBaseInfo?.skuId,
        grouponid: grouponId
      })
      if (this.isShowList) {
        this.togglePopup('isShowList', false)
      }
      // 为确保弹层关闭后再调起规格弹层，延时100ms调起弹层
      setTimeout(() => {
        // 如果拼团，且只有一个sku，直接进行开团提交，不用打开弹层
        if (this.isSimpleGroup) {
          this.$emit('submit', { grouponId })
        } else {
          this.showSkuSelect({
            isShow: true,
            params: {
              source: 15,
              grouponId: grouponId
            }
          })
        }
      }, 100)
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
